/**
 * @author      xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { Button as ChakraButton, ButtonProps } from '@chakra-ui/react'
import { useTheme } from '@emotion/react'
import React from 'react'

import { getSizeStyle, useResponsiveValue } from '../../helpers'

import * as styles from './styles'

interface Props extends ButtonProps {
  dataTestId?: string
}

/**
 * @param root0
 * @param root0.children
 * @param root0.css
 * @param root0.dataTestId
 * @param root0.isDisabled
 * @param root0.size
 * @param root0.tabIndex
 * @param root0.isLoading
 * @param root0.spinner
 * @param root0.onClick
 * @param root0.style
 * @deprecated Please use Button from @chakra-ui/react instead
 */
export const PrimaryButton = ({
  children,
  css,
  dataTestId,
  isDisabled,
  size,
  tabIndex = 0,
  isLoading,
  spinner,
  onClick,
  style,
  ...rest
}: Props) => {
  const { name } = useTheme()
  const isSpaces = name === 'SPACES'
  return (
    <ChakraButton
      {...rest}
      css={[
        css,
        styles.button,
        getSizeStyle(useResponsiveValue(size) ?? 'md'),
        styles.primaryButton,
        isSpaces && styles.spacesButton,
      ]}
      data-testid={dataTestId}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onClick={onClick}
      spinner={spinner}
      style={style}
      tabIndex={tabIndex}
    >
      {children}
    </ChakraButton>
  )
}
